import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useMemo, useCallback, useState, useRef, useEffect, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { tuple } from '../_utils/type';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import usePopper from '../_utils/usePopper';
import Input from '../input';
import Icon from '../icon';
import Empty from '../empty';
import Checkbox from '../checkbox';
import Tag from '../tag';
import { flattenAll, useChecked, getHalfChecked, getChecked, getMultipleCheckValue, getAllCheckedKeys } from './util';
export var CascaderPlacement = tuple('topLeft', 'topRight', 'bottomLeft', 'bottomRight');
var Cascader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var allProps = getCompProps('Cascader', userDefaultProps, props);
  var mode = allProps.mode,
    style = allProps.style,
    options = allProps.options,
    bordered = allProps.bordered,
    disabled = allProps.disabled,
    children = allProps.children,
    loadData = allProps.loadData,
    clearIcon = allProps.clearIcon,
    className = allProps.className,
    fieldNames = allProps.fieldNames,
    placeholder = allProps.placeholder,
    defaultValue = allProps.defaultValue,
    maxTagPlaceholder = allProps.maxTagPlaceholder,
    displayRender = allProps.displayRender,
    expandTrigger = allProps.expandTrigger,
    changeOnSelect = allProps.changeOnSelect,
    dropdownRender = allProps.dropdownRender,
    notFoundContent = allProps.notFoundContent,
    getPopupContainer = allProps.getPopupContainer,
    defaultPopupVisible = allProps.defaultPopupVisible,
    onPopupVisibleChange = allProps.onPopupVisibleChange,
    onPopperVisibleChange = allProps.onPopperVisibleChange,
    customPrefixcls = allProps.prefixCls,
    customAllowClear = allProps.allowClear,
    popupPlacement = allProps.popupPlacement,
    maxTagCount = allProps.maxTagCount,
    autoFocus = allProps.autoFocus,
    otherProps = __rest(allProps
    // className前缀
    , ["mode", "style", "options", "bordered", "disabled", "children", "loadData", "clearIcon", "className", "fieldNames", "placeholder", "defaultValue", "maxTagPlaceholder", "displayRender", "expandTrigger", "changeOnSelect", "dropdownRender", "notFoundContent", "getPopupContainer", "defaultPopupVisible", "onPopupVisibleChange", "onPopperVisibleChange", "prefixCls", "allowClear", "popupPlacement", "maxTagCount", "autoFocus"]);
  // className前缀
  var prefixCls = getPrefixCls(pkgPrefixCls, 'cascader', customPrefixcls);
  var mergeRef = useRef();
  var inputRef = useRef();
  var suffixRef = useRef(null);
  var wrapperRef = useRef();
  var _useState = useState(!!props.popperVisible || !!props.popupVisible || defaultPopupVisible),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  React.useEffect(function () {
    setVisible(!!props.popperVisible || !!props.popupVisible);
  }, [props.popperVisible, props.popupVisible]);
  var _useState3 = useState([options]),
    _useState4 = _slicedToArray(_useState3, 2),
    menus = _useState4[0],
    setMenus = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    currentOptions = _useState6[0],
    setCurrentOptions = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedOptions = _useState8[0],
    setSelectedOptions = _useState8[1];
  var _useState9 = useState(props.value || defaultValue || []),
    _useState10 = _slicedToArray(_useState9, 2),
    value = _useState10[0],
    setValue = _useState10[1];
  React.useEffect(function () {
    props.value && setValue(props.value);
  }, [props.value]);
  var isMultiple = useMemo(function () {
    return mode === 'multiple';
  }, [mode]);
  var _useMemo = useMemo(function () {
      return flattenAll(options, []);
    }, [options]),
    flattenData = _useMemo.flattenData,
    keysData = _useMemo.keysData;
  var _useChecked = useChecked(value, flattenData, keysData, isMultiple),
    _useChecked2 = _slicedToArray(_useChecked, 2),
    checkedKeys = _useChecked2[0],
    halfCheckedKeys = _useChecked2[1];
  React.useEffect(function () {
    if (!isMultiple && value && (options === null || options === void 0 ? void 0 : options.length) > 0) {
      var _currentOptions = [];
      var _menus = [options];
      var scanOptions = function scanOptions(options) {
        options.forEach(function (option) {
          var _a;
          if (_includesInstanceProperty(value).call(value, String(option[fieldNames.value]))) {
            _currentOptions.push(option);
            if ((_a = option[fieldNames.children]) === null || _a === void 0 ? void 0 : _a.length) {
              _menus.push(option[fieldNames.children]);
              scanOptions(option[fieldNames.children]);
            }
          }
        });
      };
      scanOptions(options);
      setMenus(_menus);
      setCurrentOptions(_currentOptions);
    }
  }, [options, value, selectedOptions, fieldNames, isMultiple]);
  React.useEffect(function () {
    if (isMultiple && value && (options === null || options === void 0 ? void 0 : options.length) > 0) {
      var _currentOptions2 = [];
      var lastselectedOptions = value[(value === null || value === void 0 ? void 0 : value.length) - 1] || [];
      var _menus2 = [options];
      var scanOptions = function scanOptions(options) {
        options.forEach(function (option) {
          var _a;
          if (_includesInstanceProperty(lastselectedOptions).call(lastselectedOptions, String(option[fieldNames.value]))) {
            _currentOptions2.push(option);
            if ((_a = option[fieldNames.children]) === null || _a === void 0 ? void 0 : _a.length) {
              _menus2.push(option[fieldNames.children]);
              scanOptions(option[fieldNames.children]);
            }
          }
        });
      };
      scanOptions(options);
      var newMultipleOptions = value === null || value === void 0 ? void 0 : _mapInstanceProperty(value).call(value, function (item) {
        return Array.isArray(item) ? _mapInstanceProperty(item).call(item, function (key) {
          return keysData[key];
        }) : [];
      });
      setMenus(_menus2);
      setCurrentOptions(newMultipleOptions);
    }
  }, [options, value, fieldNames, isMultiple]);
  var handleFocus = function handleFocus() {
    var _a, _b;
    if (!disabled) {
      if (isMultiple) {
        (_a = mergeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      } else {
        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
      }
    }
  };
  var handleBlur = function handleBlur() {
    var _a, _b;
    if (!disabled) {
      if (isMultiple) {
        (_a = mergeRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      } else {
        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
      }
    }
  };
  useImperativeHandle(ref, function () {
    return {
      focus: handleFocus,
      blur: handleBlur,
      dom: mergeRef.current
    };
  });
  useEffect(function () {
    if (autoFocus) {
      handleFocus();
    }
  }, [autoFocus, inputRef]);
  var handleMouseUp = function handleMouseUp(e) {
    var _a;
    var cln = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.className;
    var isCloseBtn = cln.indexOf('kd-tag-close-icon') > -1 || cln.indexOf('kdicon') > -1;
    if (isCloseBtn) {
      e.stopPropagation();
    }
  };
  React.useEffect(function () {
    var _a;
    ;
    (_a = (isMultiple ? suffixRef : wrapperRef).current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseup', handleMouseUp);
    return function () {
      var _a;
      ;
      (_a = (isMultiple ? suffixRef : wrapperRef).current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);
  var labels = useMemo(function () {
    return !isMultiple ? _mapInstanceProperty(currentOptions).call(currentOptions, function (_ref) {
      var label = _ref[fieldNames.label];
      return label;
    }) : _mapInstanceProperty(currentOptions).call(currentOptions, function (option) {
      return _mapInstanceProperty(option).call(option, function (_ref2) {
        var label = _ref2[fieldNames.label];
        return label;
      });
    });
  }, [currentOptions, fieldNames.label, isMultiple]);
  var values = useMemo(function () {
    return !isMultiple ? _mapInstanceProperty(currentOptions).call(currentOptions, function (_ref3) {
      var value = _ref3.value;
      return value;
    }) : _mapInstanceProperty(currentOptions).call(currentOptions, function (option) {
      return _mapInstanceProperty(option).call(option, function (_ref4) {
        var value = _ref4.value;
        return value;
      });
    });
  }, [currentOptions, isMultiple]);
  var allowClear = customAllowClear && value.length > 0 && !disabled;
  var handleClear = function handleClear() {
    handleBlur();
    setVisible(false);
    onChange([]);
  };
  var renderSuffix = function renderSuffix() {
    var _classNames;
    var suffixIcon = allProps.suffixIcon;
    // 选择器下拉icon样式
    var arrowIconCls = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-arrow"), true), _defineProperty(_classNames, "".concat(prefixCls, "-icon-arrow-up"), visible), _defineProperty(_classNames, "".concat(prefixCls, "-icon-arrow-down"), !visible), _defineProperty(_classNames, "".concat(prefixCls, "-icon-arrow-focus"), visible), _classNames));
    var iconShow = allowClear && !disabled && currentOptions.length > 0;
    var clearIconCls = classNames(_defineProperty({}, "".concat(prefixCls, "-icon-clear"), true));
    return /*#__PURE__*/React.createElement(React.Fragment, null, iconShow && /*#__PURE__*/React.createElement("span", {
      onClick: handleClear,
      className: clearIconCls
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid"
    }) || clearIcon), /*#__PURE__*/React.createElement("span", {
      className: arrowIconCls
    }, suffixIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down"
    })));
  };
  var handleMaxTagHolder = useCallback(function () {
    if (typeof maxTagPlaceholder === 'function') {
      return /*#__PURE__*/React.createElement(Tag, {
        type: "edit",
        disabled: disabled
      }, maxTagPlaceholder(currentOptions));
    } else {
      return /*#__PURE__*/React.createElement(Tag, {
        type: "edit",
        disabled: disabled
      }, maxTagPlaceholder);
    }
  }, [disabled, maxTagPlaceholder, currentOptions]);
  var handleRemove = function handleRemove(e, opt) {
    e.stopPropagation();
    onMultipleChecked(_toConsumableArray(opt).pop(), false);
  };
  var renderMultiple = function renderMultiple() {
    var _classNames3, _classNames4;
    var multipleCls = classNames((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-expand"), visible), _defineProperty(_classNames3, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-multiple"), true), _defineProperty(_classNames3, "".concat(prefixCls, "-bordered"), bordered), _classNames3));
    var itemCls = classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-selection-item"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-tag-describe"), true), _classNames4));
    var TagStyle = {
      margin: '2px 8px 2px 0',
      maxWidth: '100%'
    };
    return /*#__PURE__*/React.createElement("div", _extends({
      className: multipleCls,
      ref: mergeRef,
      style: style
    }, otherProps, {
      tabIndex: -1
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-multiple-wrapper"),
      ref: wrapperRef
    }, Array.isArray(currentOptions) && /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(currentOptions).call(currentOptions, function (option, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: _JSON$stringify(values[index]),
        className: classNames("".concat(prefixCls, "-selection-tag"))
      }, (!maxTagCount || index <= maxTagCount - 1) && /*#__PURE__*/React.createElement(Tag, {
        type: "edit",
        disabled: disabled,
        style: TagStyle,
        closable: true,
        onClose: function onClose(e) {
          return handleRemove(e, option);
        }
      }, displayRender(labels[index], option)));
    }), maxTagCount && currentOptions.length > maxTagCount ? maxTagPlaceholder ? handleMaxTagHolder() : /*#__PURE__*/React.createElement("span", {
      className: itemCls
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-tag-describe-content")
    }, "\u5171", currentOptions.length, "\u9879")) : null), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-placeholder")
    }, !currentOptions.length && placeholder)), /*#__PURE__*/React.createElement("span", {
      ref: suffixRef,
      className: "".concat(prefixCls, "-suffix")
    }, renderSuffix()));
  };
  var renderSingle = function renderSingle() {
    var _classNames5;
    var inputProps = {
      value: value,
      ref: inputRef,
      placeholder: placeholder,
      readOnly: true,
      borderType: bordered ? 'bordered' : 'underline',
      disabled: disabled,
      className: classNames("".concat(prefixCls, "-picker-input"), {
        expand: visible
      }),
      suffix: props.suffixIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "arrow-down",
        className: classNames({
          expand: visible
        })
      })
    };
    var singleProps = {
      style: style,
      tabIndex: 0,
      className: classNames("".concat(prefixCls, "-picker"), className, (_classNames5 = {}, _defineProperty(_classNames5, "".concat(prefixCls, "-single"), true), _defineProperty(_classNames5, "".concat(prefixCls, "-expand"), visible), _defineProperty(_classNames5, "allowClear", allowClear), _defineProperty(_classNames5, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames5, "".concat(prefixCls, "-bordered"), bordered), _classNames5))
    };
    return /*#__PURE__*/React.createElement("div", _extends({}, singleProps, {
      ref: mergeRef
    }, otherProps), React.Children.count(children) === 1 && children.type ? /*#__PURE__*/React.cloneElement(children) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-single-wrapper"),
      ref: wrapperRef
    }, /*#__PURE__*/React.createElement(Input, _extends({}, inputProps)), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-picker-label")
    }, (labels === null || labels === void 0 ? void 0 : labels.length) ? displayRender(labels, currentOptions) : ''), allowClear && /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid",
      className: "".concat(prefixCls, "-picker-close"),
      onClick: handleClear
    }))));
  };
  var cascaderLocator = isMultiple ? renderMultiple() : renderSingle();
  var onExpend = function onExpend(index, opt, opts) {
    _spliceInstanceProperty(selectedOptions).call(selectedOptions, index, selectedOptions.length - index, opt);
    setSelectedOptions(selectedOptions);
    if (!(opts === null || opts === void 0 ? void 0 : opts.length) && opt.isLeaf !== false || changeOnSelect) {
      onChange(selectedOptions);
    }
    !(opts === null || opts === void 0 ? void 0 : opts.length) && opt.isLeaf !== false && setVisible(false);
    var newMenus = _toConsumableArray(menus);
    if ((opts === null || opts === void 0 ? void 0 : opts.length) || opt.isLeaf === false) {
      _spliceInstanceProperty(newMenus).call(newMenus, index + 1, newMenus.length - index + 1, opts);
    }
    setMenus(newMenus);
    loadData && opt.isLeaf === false && !(opts === null || opts === void 0 ? void 0 : opts.length) && loadData(selectedOptions);
  };
  var onMultipleExpend = function onMultipleExpend(index, opt, opts) {
    _spliceInstanceProperty(selectedOptions).call(selectedOptions, index, selectedOptions.length - index, opt);
    setSelectedOptions(selectedOptions);
    var newMenus = _toConsumableArray(menus);
    if ((opts === null || opts === void 0 ? void 0 : opts.length) || opt.isLeaf === false) {
      _spliceInstanceProperty(newMenus).call(newMenus, index + 1, newMenus.length - index + 1, opts);
    }
    setMenus(newMenus);
    loadData && opt.isLeaf === false && !(opts === null || opts === void 0 ? void 0 : opts.length) && loadData(selectedOptions);
  };
  var onMultipleChecked = function onMultipleChecked(opt, checked) {
    var _a;
    var checkState = getAllCheckedKeys(opt.value, checked, checkedKeys, keysData, halfCheckedKeys);
    var newValue = getMultipleCheckValue(value, opt, checked, flattenData, checkState.checkedKeys);
    var newMultipleOptions = newValue === null || newValue === void 0 ? void 0 : _mapInstanceProperty(newValue).call(newValue, function (item) {
      return Array.isArray(item) ? _mapInstanceProperty(item).call(item, function (key) {
        return keysData[key];
      }) : [];
    });
    if (!('value' in props)) {
      setValue(newValue);
    }
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, newValue, newMultipleOptions);
  };
  var onChange = function onChange(selectedOptions) {
    var selectedValue = _mapInstanceProperty(selectedOptions).call(selectedOptions, function (_ref5) {
      var value = _ref5[fieldNames.value];
      return value;
    });
    if (typeof props.value === 'undefined') {
      setCurrentOptions(selectedOptions);
      setValue(selectedValue);
    }
    props.onChange && props.onChange(selectedValue, selectedOptions);
  };
  var onVisibleChange = function onVisibleChange(visible) {
    setVisible(visible);
    onPopupVisibleChange && onPopupVisibleChange(visible);
    onPopperVisibleChange && onPopperVisibleChange(visible);
    visible && setSelectedOptions(_sliceInstanceProperty(currentOptions).call(currentOptions, 0));
  };
  var cascaderMenus = /*#__PURE__*/React.createElement(React.Fragment, null, (options === null || options === void 0 ? void 0 : options.length) ? (menus === null || menus === void 0 ? void 0 : menus.length) && _mapInstanceProperty(menus).call(menus, function (opts, index) {
    return /*#__PURE__*/React.createElement("ul", {
      key: index,
      className: "".concat(prefixCls, "-menu")
    }, (opts === null || opts === void 0 ? void 0 : opts.length) && _mapInstanceProperty(opts).call(opts, function (opt) {
      var isLeaf = opt.isLeaf,
        loading = opt.loading,
        value = opt[fieldNames.value],
        label = opt[fieldNames.label],
        children = opt[fieldNames.children];
      var expendEvent = expandTrigger === 'click' || !(children && children.length) ? 'onClick' : 'onMouseEnter';
      var selected = selectedOptions[index] && selectedOptions[index][fieldNames.value] === value;
      var optionProps = {
        role: 'menuitem',
        className: classNames("".concat(prefixCls, "-menu-item"), {
          disabled: opt.disabled,
          last: !(children === null || children === void 0 ? void 0 : children.length) && isLeaf !== false,
          selected: selected
        })
      };
      if (!opt.disabled) {
        optionProps[expendEvent] = isMultiple ? onMultipleExpend.bind(null, index, opt, children) : onExpend.bind(null, index, opt, children);
      }
      var node = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-menu-item-label")
      }, label), loading ? /*#__PURE__*/React.createElement(Icon, {
        type: "loadding-circle",
        spin: true
      }) : ((children === null || children === void 0 ? void 0 : children.length) || isLeaf === false) && (props.expandIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "arrow-right"
      })));
      return /*#__PURE__*/React.createElement("li", _extends({
        key: value
      }, optionProps, {
        title: label
      }), isMultiple ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
        checked: getChecked(checkedKeys, value),
        indeterminate: getHalfChecked(halfCheckedKeys, value),
        disabled: opt.disabled,
        onChange: function onChange(e) {
          return onMultipleChecked(opt, e.target.checked);
        },
        className: "".concat(prefixCls, "-checkbox")
      }), node) : node);
    }));
  }) : /*#__PURE__*/React.createElement(Empty, {
    description: notFoundContent
  }));
  var cascaderPopper = dropdownRender(cascaderMenus);
  var popperProps = _extends(_extends({}, allProps), {
    gap: 4,
    visible: visible,
    onVisibleChange: onVisibleChange,
    trigger: expandTrigger,
    getPopupContainer: getPopupContainer,
    prefixCls: "".concat(prefixCls, "-menus"),
    placement: allProps.popperPlacement || popupPlacement,
    popperClassName: allProps.popperClassName || allProps.popupClassName,
    getTriggerElement: function getTriggerElement() {
      return mergeRef.current;
    }
  });
  return usePopper(cascaderLocator, cascaderPopper, popperProps);
});
Cascader.displayName = 'Cascader';
export default Cascader;